
import { Vue, Component, Ref, Watch, Prop } from 'vue-property-decorator';
import { ICarSPUField } from '@/common/interface/carSpu';
import { ECarSPUField } from '@/common/enum/carSpu';
import { FormModel } from 'ant-design-vue';
import { DebounceTime } from '@/common/decorator';
// import { CarSPU } from '@/models/car.model';

import NameField from '@/components/carModule/fields/NameField.vue';
import FirstRegistrationDateField from '@/components/carModule/fields/FirstRegistrationDateField.vue';
import MileageField from '@/components/carModule/fields/MileageField.vue';
import CarLocationfield from '@/components/carModule/fields/CarLocationfield.vue';
import TransferTimesField from '@/components/carModule/fields/TransferTimesField.vue';
import UseTofield from '@/components/carModule/fields/UseTofield.vue';
import ColorField from '@/components/carModule/fields/ColorField.vue';
import InteriorColorField from '@/components/carModule/fields/InteriorColorField.vue';
import GearNameField from '@/components/carModule/fields/GearNameField.vue';
import VinCodeField from '@/components/carModule/fields/VinCodeField.vue';
import ExteriorInfoField from '@/components/carModule/fields/ExteriorInfoField.vue';
import LiterField from '@/components/carModule/fields/LiterField.vue';
import AccidentInfoField from '@/components/carModule/fields/AccidentInfoField.vue';
import HighlightsField from '@/components/carModule/fields/HighlightsField.vue';
import VehicleSourceProcedureInformationField from '@/components/carModule/fields/VehicleSourceProcedureInformationField.vue';
import VehicleSourceInformationField from '@/components/carModule/fields/VehicleSourceInformationField.vue';
import VehicleSourcePriceInformationField from '@/components/carModule/fields/VehicleSourcePriceInformationField.vue';
import InformationOnTheLocationOfTheVehicleSourceField from '@/components/carModule/fields/InformationOnTheLocationOfTheVehicleSourceField.vue';
import DescriptionField from '@/components/carModule/fields/DescriptionField.vue';
import SwitchField from '@/components/carModule/fields/SwitchField.vue';
import BrandCarSeriesModelsField from '@/components/carModule/fields/BrandCarSeriesModelsField.vue';
import ImagesField from '@/components/carModule/fields/ImagesField.vue';
import LicenseInformationModuleField from './fields/LicenseInformationModuleField.vue';
import UploadImageField from '@/components/carModule/fields/UploadImageField.vue';
import CarDimensionsField from '@/components/carModule/fields/CarDimensionsField.vue';
import CarCompartmentTypeField from '@/components/carModule/fields/CarCompartmentTypeField.vue';

import lazyInject from '@/di';
import CarService from '@/services/car.service';
import ShopService from '@/services/shop.service';
import { City } from '@/common/interface';

import PriceTrendModal from '@/components/carModule/fields/PriceTrendModal.vue';

@Component({
  components: {
    PriceTrendModal,
  },
})
export default class SPUcar extends Vue {
  @Ref('')
  vehicleSourceProcedureInformation!: VehicleSourceProcedureInformationField;
  @Ref('')
  informationOnTheLocationOfTheVehicleSource!: InformationOnTheLocationOfTheVehicleSourceField;
  @Ref('')
  vehicleSourceInformation!: VehicleSourceInformationField;
  @Ref('')
  vehicleSourcePriceInformation!: VehicleSourcePriceInformationField;
  @Ref('')
  licenseInformationModule!: LicenseInformationModuleField;

  @lazyInject(CarService)
  carService!: CarService;
  @lazyInject(ShopService)
  shopService!: ShopService;

  @Ref('priceTrendModal')
  priceTrendModal!: PriceTrendModal;

  @Prop()
  shopId!: any;

  @Prop()
  type!: any;

  catType = false;

  visible = false;

  carTypoe = '1';

  citys: City[] = [];

  options: any = [];

  title = '添加信息';

  current = 0;

  form: { [key: string]: any } = {};

  formItems: ICarSPUField[] = [];
  formOldItems: ICarSPUField[] = [];

  rules: { [key: string]: any } = {};

  rulesType: any = true;

  @Ref()
  readonly ruleForm!: FormModel;

  @DebounceTime(300)
  @Watch('form', { deep: true })
  watchForm() {
    if (!this.form) {
      return;
    }
    // console.log(this.form);

    this.update();
  }

  uploadFile(val: any, label: string) {
    // console.log(val, label);
    if (label === 'brandCarSeriesModels') {
      this.form[label] = val;
      return;
    }
    this.$set(this.form, label, val);
    this.onValiFormDataChange();
  }

  oldparams: any = {};

  reportData: any = {};

  validItems: any = {};

  async onValiFormDataChange() {
    const { mileage, firstRegistrationDate, model_id } = this.form;
    if (!this.form.licenseInformationModule) {
      return;
    }
    if (+this.carTypoe === 2) {
      return;
    }
    // console.log(this.formItems);
    const { plateCityId } = this.form.licenseInformationModule;
    const isEmpty = (val: any) =>
      val == null ||
      (typeof val === 'string' && val.trim() === '') ||
      val === 0;
    if (
      !isEmpty(plateCityId) &&
      !isEmpty(mileage) &&
      !isEmpty(firstRegistrationDate) &&
      !isEmpty(model_id)
    ) {
      const params = {
        plate_city_id: plateCityId,
        mileage,
        first_registration_date: firstRegistrationDate,
        model_id,
      };
      if (JSON.stringify(this.oldparams) === JSON.stringify(params)) {
        return;
      }
      this.oldparams = params;
      try {
        const res = await this.carService.getCarEval(params);
        if (res) {
          const { defaultCondition, evalInfo } = res.report;
          const validItems = evalInfo.find(
            (item: any) => item.condition == defaultCondition,
          );
          this.reportData = res.report;
          this.validItems = validItems;
        } else {
          this.reportData = {};
          this.validItems = {};
        }
      } catch (error) {
        // console.log(error);
        this.reportData = {};
        this.validItems = {};
      }
    }
  }

  update() {}

  changeDinebssins(value: any) {
    this.form.car_dimensions = value;
  }

  choiceTypoe(val: any) {
    this.$emit('choiceTypoe', val);
    this.carTypoe = val;
    this.catType = false;
  }

  lookPriceTrend() {
    this.priceTrendModal.init({});
  }

  getPersonalTrade() {
    const { dealerBuy } = this.validItems;
    if (!dealerBuy) return '';
    const text = `${dealerBuy.min}~${dealerBuy.max}`;
    return text;
  }

  vinModel(val: any) {
    // console.log(val, 'vinModel');
    this.form.brandName = val.brand;
    this.form.modelName = val.modelName;
    this.form.seriesName = val.series;
    this.form.brand_id = val.brandId;
    this.form.series_id = val.seriesId;
    this.form.model_id = val.modelId;
    this.onValiFormDataChange();
  }

  brandCarSeriesModels(val: any) {
    // console.log(val, 'brandCarSeriesModels');
    this.form.gearName = val.gearName;
    this.form.liter = val.liter;
    this.form.officialPrice = val.official_price;
    this.form.brand_id = val.brandId;
    this.form.series_id = val.seriesId;
    this.form.model_id = val.modelId;
    this.form.brandName = val.brand;
    this.form.modelName = val.modelName;
    this.form.seriesName = val.series;
    this.form.vehicleSourcePriceInformation.officialPrice = val.official_price;
    this.changeRules();
  }

  changeRules() {
    // console.log(this.formItems, this.form, 'formItems');
    const { brandName, modelName, seriesName } = this.form;
    if (
      brandName.includes('其他') &&
      modelName.includes('其他') &&
      seriesName.includes('其他')
    ) {
      // this.formItems = this.formOldItems;
      this.rulesType = false;

      const labelsToClear = [
        ECarSPUField.FIRST_REGISTRATION_DATE,
        ECarSPUField.MILEAGE,
        ECarSPUField.TRANSFER_TIMES,
        ECarSPUField.INTERIOR_COLOR,
        ECarSPUField.USE_TO,
        ECarSPUField.VIN_CODE,
      ];
      const newFormItems = this.formItems.map((item) => {
        if (labelsToClear.includes(item.label)) {
          return {
            ...item,
            rule: [], // 覆盖原来的 rule
          };
        }
        if (item.label === ECarSPUField.NAME) {
          return {
            ...item,
            isHidden: false,
          };
        }
        return item;
      });
      this.formItems = newFormItems;
      this.setRulesAndFormItems(newFormItems);
    } else {
      this.formItems = this.formOldItems;
      this.setRulesAndFormItems(this.formOldItems);

      this.rulesType = true;
    }
  }

  open() {
    if (this.type === 'addspu') {
      this.catType = true;
    }
    this.visible = true;
    // this.form = new CarSPU();
    this.getCityList();
    this.current = 0;
  }
  onClose() {
    this.visible = false;
    this.form = {};
    this.oldparams = {};
    this.validItems = {};
    this.ruleForm.clearValidate([]);
  }
  shouldResetFields: any = '';
  setup(
    fields: ICarSPUField[],
    spuForm: { [key: string]: any },
    shouldResetFields?: boolean,
  ) {
    this.shouldResetFields = shouldResetFields;
    this.formItems = fields;
    this.formOldItems = fields;
    this.form = spuForm;
    this.carTypoe = spuForm.car_type;
    this.setRulesAndFormItems(fields, true);
  }
  setRulesAndFormItems(fields: ICarSPUField[], shouldResetFields?: boolean) {
    this.formItems = [...fields];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const rules: any = {};
    for (const field of fields) {
      rules[field.label] =
        field.rule && field.rule.length ? field.rule : undefined;
    }

    const ruleKeys = Object.keys(rules);
    for (const key of ruleKeys) {
      if (rules[key] === undefined) {
        delete rules[key];
      }
    }
    this.rules = rules;
    if (shouldResetFields) {
      this.open();
    }
  }

  getComponent(label: ECarSPUField) {
    switch (label) {
      case ECarSPUField.NAME:
        return MileageField;
      case ECarSPUField.BRAND_CAR_SERIES_MODELS:
        return BrandCarSeriesModelsField;
      case ECarSPUField.FIRST_REGISTRATION_DATE:
        return FirstRegistrationDateField;
      case ECarSPUField.MILEAGE:
        return MileageField;
      case ECarSPUField.CAR_LOCATION:
        return CarLocationfield;
      case ECarSPUField.TRANSFER_TIMES:
        return TransferTimesField;
      case ECarSPUField.USE_TO:
        return UseTofield;
      case ECarSPUField.COLOR:
        return ColorField;
      case ECarSPUField.INTERIOR_COLOR:
        return InteriorColorField;
      case ECarSPUField.GEAR_NAME:
        return GearNameField;
      case ECarSPUField.VIN_CODE:
        return VinCodeField;
      case ECarSPUField.EXTERIOR_INFO:
        return ExteriorInfoField;
      case ECarSPUField.LITER:
        return LiterField;
      case ECarSPUField.ACCIDENT_INFO:
        return AccidentInfoField;
      case ECarSPUField.HIGHLIGHTS:
        return HighlightsField;
      case ECarSPUField.VEHICLE_SOURCE_PROCEDURE_INFORMATION:
        return VehicleSourceProcedureInformationField;
      case ECarSPUField.VEHICLE_SOURCE_INFORMATION:
        return VehicleSourceInformationField;
      case ECarSPUField.VEHICLE_SOURCE_PRICE_INFORMATION:
        return VehicleSourcePriceInformationField;
      case ECarSPUField.INFORMATION_ON_THE_LOCATION_OF_THE_VEHICLE_SOURCE:
        return InformationOnTheLocationOfTheVehicleSourceField;
      case ECarSPUField.DESCRIPTION:
        return DescriptionField;
      case ECarSPUField.AUTOMATIC_SHELVING:
        return SwitchField;
      case ECarSPUField.AUTOMATIC_DELISTING:
        return SwitchField;
      case ECarSPUField.CAR_IMAGES:
        return ImagesField;
      case ECarSPUField.VERIFICATION_IMAGES:
        return UploadImageField;
      case ECarSPUField.HEADER_IMAGE:
        return UploadImageField;
      case ECarSPUField.LICENSE_INFORMATION_MODULE:
        return LicenseInformationModuleField;
      case ECarSPUField.REFIT_CHARGE:
        return MileageField;
      case ECarSPUField.EVALUATION_PRICE:
        return MileageField;
      case ECarSPUField.CAR_DIMENSIONS:
        return CarDimensionsField;
      case ECarSPUField.MAX_TOTAL_MASS:
        return MileageField;
      case ECarSPUField.WHEELBASE:
        return MileageField;
      case ECarSPUField.SHAFTS_NUMBER:
        return MileageField;
      case ECarSPUField.CAR_COMPARTMENT_TYPE:
        return CarCompartmentTypeField;
      default:
        return NameField;
    }
  }

  /** 获取城市里列表 */
  async getCityList() {
    const res = await this.shopService.getAllRegion();
    if (res) {
      this.options = res;
    } else {
      this.options = [];
    }
    const localCity = localStorage.getItem('localCity');
    if (localCity) {
      this.citys = JSON.parse(localCity);
    } else {
      const payload = {
        covered: true,
        joined: true,
        aggregation: false,
      };
      const response = (await this.shopService.getCityList(
        payload,
      )) as unknown as {
        [key: string]: {
          province: City;
          city: City[];
        };
      };
      if (response) {
        const citys = Object.values(response)
          .map((item) => item.city)
          .reduce((prev, cur) => prev.concat(cur), []);
        this.citys = citys;
      } else {
        this.citys = [];
      }
    }
  }

  async submit() {
    this.ruleForm.validate((valid) => {
      if (valid) {
        this.$emit('submit', this.form);
      }
    });
  }

  // async addCarCommodity() {
  //   const res = await this.carService.addCarCommodity(this.form);
  //   console.log(res);
  // }

  itemLabel(label: string) {
    return label;
  }

  prevSteps() {
    this.current--;
  }

  /**
   * 下一步
   * 校验子组件中必填属性
   * validateFields() 子组件校验方法
   * 校验通过后，切换到下一个步骤
   */
  async nextSteps() {
    // console.log(this.form);
    if (this.current === 0) {
      this.ruleForm.validate((valid) => {
        if (valid) {
          this.current = 1;
        }
      });
    } else if (this.current === 1) {
      this.ruleForm.clearValidate([]);
      const _list: any = {
        license_information_module: this.licenseInformationModule as any,
        vehicle_source_price_information: this
          .vehicleSourcePriceInformation as any,
        information_on_the_location_of_the_vehicle_source: this
          .informationOnTheLocationOfTheVehicleSource as any,
        vehicle_source_procedure_information: this
          .vehicleSourceProcedureInformation as any,
        vehicle_source_information: this.vehicleSourceInformation as any,
      };
      try {
        // console.log(_list);
        // 采用 Promise.all 并发校验
        const res = await Promise.all(
          Object.keys(_list).map((key) => {
            return (_list[key] as any)[0].validateFields();
          }),
        );
        const valid = res.includes(false);
        if (valid) {
          return;
        } else {
          this.current = 2;
        }
      } catch (e: any) {
        // console.error(e);
        this.$message.error(e);
      }
    } else {
      this.current++;
    }
  }
}
